import { createFill } from './utils/fill';

export function renderPath(stageContext, node) {
  const { context } = stageContext;

  if (!node.path) return;

  context.save();
  context.strokeStyle = '';
  context.fillStyle = '';
  context.translate(node.x, node.y);

  // Create a new path
  context.beginPath();

  // Parse and draw the SVG path
  const path = new Path2D(node.path);

  // Apply overall opacity
  const globalOpacity = node.opacity !== undefined ? node.opacity : 1;
  context.globalAlpha = globalOpacity;

  // Apply fill if specified
  if (node.fill && node.fill !== 'none' && node.fill !== 'transparent') {
    // Use createFill to support gradients
    createFill(stageContext, node.fill, node, () => {
      if (node.fillOpacity !== undefined && node.fillOpacity !== 1) {
        // Apply fill opacity
        const originalGlobalAlpha = context.globalAlpha;
        context.globalAlpha = node.fillOpacity * globalOpacity;
        context.fill(path, node.fillRule || 'nonzero');
        context.globalAlpha = originalGlobalAlpha;
      } else {
        context.fill(path, node.fillRule || 'nonzero');
      }
    });
  }

  // Apply stroke if specified
  if (node.stroke && node.stroke !== 'none') {
    context.strokeStyle = node.stroke;
    context.lineWidth = node.strokeWidth ?? 0;

    // Apply stroke line cap
    if (node.strokeLinecap) {
      context.lineCap = node.strokeLinecap;
    }

    // Apply stroke line join
    if (node.strokeLinejoin) {
      context.lineJoin = node.strokeLinejoin;
    }

    // Apply stroke miter limit
    if (node.strokeMiterlimit !== undefined) {
      context.miterLimit = node.strokeMiterlimit;
    }

    // Apply stroke dasharray if specified
    if (node.strokeDasharray && node.strokeDasharray !== '') {
      // Parse dasharray - handle both comma and space separated values
      const dashArray = node.strokeDasharray
        .replace(/px/g, '') // Remove 'px' units
        .split(/[\s,]+/)
        .map((val) => parseFloat(val.trim()))
        .filter((val) => !isNaN(val) && val > 0);

      if (dashArray.length > 0) {
        context.setLineDash(dashArray);

        // Apply stroke dash offset if specified
        if (node.strokeDashoffset !== undefined) {
          context.lineDashOffset = node.strokeDashoffset;
        }
      }
    }

    // Apply stroke opacity
    if (node.strokeOpacity !== undefined && node.strokeOpacity !== 1) {
      const originalGlobalAlpha = context.globalAlpha;
      context.globalAlpha = node.strokeOpacity * globalOpacity;
      context.stroke(path);
      context.globalAlpha = originalGlobalAlpha;
    } else {
      context.stroke(path);
    }

    // Reset dash settings
    context.setLineDash([]);
  }

  context.closePath();
  context.restore();
}
